
import React, { useEffect, useState } from 'react';
import URLManager from '../funcionalidadeNavbar/URLManager';
import './DetalhesPedidoVenda.css';

const DetalhesPedidoVenda = ({ pedidoId, onVoltar, onAtualizado }) => {
  const _url = URLManager.getBaseURL();

  const [pedido, setPedido] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(null);
  const [feedback, setFeedback] = useState(null);

  // Campos editáveis
  
  const [dataPedido, setDataPedido] = useState('');
  const [status, setStatus] = useState('');
  const [cor, setCor] = useState('');
  const [grade, setGrade] = useState([]); // [{numero, quantidade}]
  const [quantidadeTotal, setQuantidadeTotal] = useState(0);

  const mostrarMensagem = (mensagem, tipo = 'success') => {
    setFeedback({ type: tipo, message: mensagem });
    setTimeout(() => setFeedback(null), 4000);
  };

  const parseGradeNumeracao = (gradeJson) => {
    try {
      if (!gradeJson) return {};
      if (typeof gradeJson === 'string') return JSON.parse(gradeJson);
      return gradeJson;
    } catch {
      return {};
    }
  };

  const gradeObjToArray = (obj) => Object.entries(obj || {}).map(([numero, qtd]) => ({ numero, quantidade: Number(qtd || 0) }));
  const gradeArrayToObj = (arr) => {
    const o = {};
    arr.forEach(it => { o[it.numero] = Number(it.quantidade || 0); });
    return o;
  };

  const calcularTotalPares = (arr) => arr.reduce((s, it) => s + Number(it.quantidade || 0), 0);

  const formatarConsumo = (item) => {
    if (item?.consumoFormatado && String(item.consumoFormatado).trim() !== '') {
      return String(item.consumoFormatado);
    }

    const valor = Number(item?.consumoTotal);
    if (!Number.isFinite(valor)) {
      return '-';
    }

    return valor.toFixed(4);
  };

  const obterMateriasPrimasConsolidadas = (pedidoAtual) => {
    const lista = pedidoAtual?.materiasPrimas;
    if (!Array.isArray(lista)) {
      return [];
    }

    return lista.map((item) => {
      const descricaoCompleta = item?.descricaoCompleta?.trim();
      const materiaPrima = item?.materiaPrima?.trim();
      const cor = item?.cor?.trim();

      return {
        descricao: descricaoCompleta || [materiaPrima, cor].filter(Boolean).join(' ') || '-',
        codigo: item?.codigo ?? null,
        unidade: item?.unidade || '-',
        consumoFormatado: formatarConsumo(item)
      };
    });
  };

  useEffect(() => {
    if (!pedidoId) return;
    setLoading(true);
    setErro(null);

    // Como o backend não expõe GET /pedido-venda/{id}, buscar da lista e filtrar
    fetch(`${_url}/pedido-venda/lista`, {
      headers: {
        'Authorization': `Bearer ${sessionStorage.getItem('usuarioToken')}`
      }
    })
      .then(res => {
        if (!res.ok) throw new Error('Erro ao buscar pedidos');
        return res.json();
      })
      .then(lista => {
        const encontrado = (lista || []).find(p => String(p.id) === String(pedidoId));
        if (!encontrado) throw new Error('Pedido não encontrado');
        setPedido(encontrado);

        
        setDataPedido(encontrado.dataPedido || '');
        setStatus(encontrado.status || 'Pendente');
        setCor(encontrado.cor || '');
        const gArr = gradeObjToArray(parseGradeNumeracao(encontrado.gradeNumeracao));
        setGrade(gArr);
        setQuantidadeTotal(calcularTotalPares(gArr));
      })
      .catch(err => setErro(err.message || 'Erro ao buscar detalhes'))
      .finally(() => setLoading(false));
  }, [pedidoId, _url]);

  const atualizarQuantidade = (idx, valor) => {
    const nova = [...grade];
    nova[idx].quantidade = valor === '' ? 0 : Number(valor);
    setGrade(nova);
    setQuantidadeTotal(calcularTotalPares(nova));
  };

  const removerNumero = (idx) => {
    const nova = grade.filter((_, i) => i !== idx);
    setGrade(nova);
    setQuantidadeTotal(calcularTotalPares(nova));
  };

  const extractProdutoId = (produtoField) => {
    if (produtoField == null) return undefined;
    if (typeof produtoField === 'number') return produtoField;
    if (typeof produtoField === 'string') return Number(produtoField);
    if (typeof produtoField === 'object') {
      // Tentativas comuns de nome de chave
      return (
        produtoField.idProduto ??
        produtoField.id ??
        produtoField.produtoId ??
        produtoField['id_produto'] ??
        undefined
      );
    }
    return undefined;
  };

  const salvarAlteracoes = async () => {
    if (!pedido) return;
    try {
      const dto = {
        
        dataPedido,
        status,
        cor,
        gradeNumeracao: gradeArrayToObj(grade),
        quantidadeTotal,
        
        idProduto: extractProdutoId(pedido.idProduto) // backend espera idProduto (long) na alteração
      };

      const res = await fetch(`${_url}/pedido-venda/alterar/${pedido.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem('usuarioToken')}`
        },
        body: JSON.stringify(dto)
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data || 'Erro ao salvar alterações');

      mostrarMensagem('Pedido atualizado com sucesso!', 'success');
      if (onAtualizado) onAtualizado(data);
    } catch (e) {
      mostrarMensagem(e.message || 'Erro ao salvar alterações', 'error');
    }
  };

  return (
    <div className="detalhes-pedido-container">
      <div className="header">
        <h2>Detalhes do Pedido de Venda</h2>
        <div className="header-actions">
          <button className="btn-voltar" onClick={onVoltar}>Voltar</button>
          <button className="btn-salvar" onClick={salvarAlteracoes} disabled={loading}>Salvar Alterações</button>
        </div>
      </div>

      {feedback && (
        <div className={`feedback-message ${feedback.type}`}>
          {feedback.message}
        </div>
      )}

      {loading && <div className="loading">Carregando...</div>}
      {erro && <div className="erro">{erro}</div>}

      {!loading && !erro && pedido && (
        <div className="detalhes-content">
          {(() => {
            const materiasPrimasConsolidadas = obterMateriasPrimasConsolidadas(pedido);
            return (
              <>
          <div className="pedido-info">
            <div><b>ID:</b> {pedido.id}</div>
            <div className="form-row">
              
              <div className="form-group">
                <label>Data do Pedido</label>
                <input type="date" value={dataPedido?.slice(0,10) || ''} onChange={e => setDataPedido(e.target.value)} />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Status</label>
                <select value={status} onChange={e => setStatus(e.target.value)}>
                  <option value="Pendente">Pendente</option>
                  <option value="Em Produção">Em Produção</option>
                  <option value="Concluído">Concluído</option>
                  <option value="Cancelado">Cancelado</option>
                </select>
              </div>
              <div className="form-group">
                <label>Cor</label>
                <input type="text" value={cor} onChange={e => setCor(e.target.value)} />
              </div>
            </div>
          </div>

          <fieldset className="grade-fieldset">
            <legend>Grade de Numeração</legend>
            {grade.length === 0 ? (
              <p>Sem itens na grade.</p>
            ) : (
              <table className="grade-table">
                <thead>
                  <tr>
                    <th>Número</th>
                    <th>Quantidade</th>
                    <th>Ações</th>
                  </tr>
                </thead>
                <tbody>
                  {grade.map((item, idx) => (
                    <tr key={`g-${idx}`}>
                      <td>{item.numero}</td>
                      <td>
                        <input
                          type="number"
                          min="0"
                          value={item.quantidade}
                          onChange={e => atualizarQuantidade(idx, e.target.value)}
                          className="input-qtd"
                        />
                      </td>
                      <td>
                        <button className="btn-remover" onClick={() => removerNumero(idx)}>Remover</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}

            <div className="total-pares"><b>Total de pares:</b> {quantidadeTotal}</div>
          </fieldset>

          <fieldset className="materias-fieldset">
            <legend>Matérias-Primas Consolidadas</legend>
            {materiasPrimasConsolidadas.length === 0 ? (
              <p>Nenhuma matéria-prima consolidada retornada para este pedido.</p>
            ) : (
              <div className="materias-table-wrapper">
                <table className="materias-table">
                  <thead>
                    <tr>
                      <th>Descrição</th>
                      <th>Código</th>
                      <th>Unidade</th>
                      <th>Consumo Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {materiasPrimasConsolidadas.map((item, idx) => (
                      <tr key={`mp-${idx}`}>
                        <td>{item.descricao}</td>
                        <td>{item.codigo ?? '-'}</td>
                        <td>{item.unidade}</td>
                        <td>{item.consumoFormatado}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </fieldset>
              </>
            );
          })()}
        </div>
      )}
    </div>
  );
};

export default DetalhesPedidoVenda;
